var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/clock"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.69044 9.23572C7.48709 9.13967 7.34639 8.93271 7.34639 8.69289V6.11174C7.34639 5.78037 7.61502 5.51174 7.94639 5.51174C8.27776 5.51174 8.54639 5.78037 8.54639 6.11174V8.34741L9.70327 9.01534C9.99025 9.18103 10.0886 9.54798 9.92289 9.83496C9.7572 10.1219 9.39025 10.2203 9.10327 10.0546L7.739 9.26691C7.72216 9.25719 7.70597 9.24677 7.69044 9.23572Z",
    fill: "#637182"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4001 8.49998C14.4001 12.0346 11.5347 14.9 8.0001 14.9C4.46548 14.9 1.6001 12.0346 1.6001 8.49998C1.6001 4.96535 4.46548 2.09998 8.0001 2.09998C11.5347 2.09998 14.4001 4.96535 14.4001 8.49998ZM13.2001 8.49998C13.2001 11.3719 10.872 13.7 8.0001 13.7C5.12822 13.7 2.8001 11.3719 2.8001 8.49998C2.8001 5.62809 5.12822 3.29998 8.0001 3.29998C10.872 3.29998 13.2001 5.62809 13.2001 8.49998Z",
    fill: "#637182"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon-clock.2ddc6bac398eacff307249bc1bdc7aa6.svg";
export { ForwardRef as ReactComponent };